import { baseUrl } from "../../../../boot";
import axios from "axios";

// Add company
export const addCompany = async (formData) => {
  console.log("company form data ---- ", formData);
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}crm/api/v1/create-company`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}


// delete company  API
export const deleteCompany = async (ROWID) => {
  console.log({ ROWID })
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.delete(`${baseUrl}crm/api/v1/delete-company/${ROWID}`, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    console.log("Error is - ", error)
    throw error
  }
}

// update companys
export const updateCompany = async (ROWID, data) => {
  console.log({ data })
  // const ROWID = data.ROWID
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.put(`${baseUrl}crm/api/v1/update-company/${ROWID}`, data, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}

// total count
export const countCompany = async (formData) => {
  console.log(formData,"count")
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}crm/api/v1/get-company-count`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}

export const getCompanyDetailById = async (id) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}crm/api/v1/get-company-by-id/${id}`, {
      headers: {
        "auth-token": token,
      }
    })
    // console.log('<<<<<<<<<<<<<<<<<<<<<companires>>>>>>>>>>>>>>>>>',response)
    return response
  } catch (error) {
    throw error
  }
}


// Add company
export const getCompanyRelatedTasks = async (formData) => {
  console.log("company form data ---- ", formData);
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}crm/api/v1/get-task-by-companyID`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}


// Add company
export const getCompanyRelatedNotes = async (formData) => {
  console.log("company form data ---- ", formData);
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}crm/api/v1/get-note-by-companyID`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}


// Add company
export const getCompanyRelatedDeals = async (formData) => {
  console.log("company form data ---- ", formData);
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}crm/api/v1/get-deal-by-companyID`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}


// Add company
export const getCompanyRelatedClients = async (formData) => {
  console.log("company form data ---- ", formData);
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}crm/api/v1/get-contact-by-companyID`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}
export const isCompanyExistWithName = async (companyName) => {
  console.log("company form data ---- ", companyName);
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}crm/api/v1/check-Company-By-CompanyName`, companyName, {
      headers: {
         'Content-Type': 'application/json',
      }
    },)
    return response.data;
  } catch (error) {
    throw error
  }
}